<!--<template>
  <v-container>
    <v-layout
      text-xs-center
      wrap>
      <v-flex mb-4>
        <h1 v-if="currentUser">
            Current user is: {{ currentUser.fullName }}
        </h1>
        <h1 v-else>
            No current user
        </h1>
      </v-flex>
    </v-layout>
  </v-container>
</template> -->
<template>
    <div v-on:click="goToSelectUser" class="current-user-root">
        <div v-if="currentUser" >{{ currentUser.fullName }}</div>
        <div v-else>{{$t('notLoggedIn')}}</div>
    </div>
</template>


<script>
export default {
    computed: {
        currentUser() { return this.$store.state.currentUser },
    },
    methods: {
        goToSelectUser(){
            this.$router.push({ name: 'userSelect'}) //params: ... 
        }
    }
}
</script>

<style scoped>
  .current-user-root { cursor: pointer; }
</style>